<template>
<div id="researcher">
  <div class="sectionIntro">
    <div class="sectionBack">
    </div>
    <div class="sectionContent">
      <div class="introCover">
        <img src="@/../static/image/content/researcherAvatar.png" />
      </div>
      <div class="introContent">
        <h2>{{$t('avatamsaka.researcher.name')}}</h2>
        <p>
          {{$t('avatamsaka.researcher.intro')}}
        </p>
      </div>
    </div>
  </div>

  <div class="itemsBlocks">
    <h2>{{$t('avatamsaka.researcher.area01')}}</h2>
    <div class="itemBlock">
      <p>
        {{$t('avatamsaka.researcher.area01content')}}
      </p>
    </div>
  </div>

  <div class="itemsBlocks">
    <h2>{{$t('avatamsaka.researcher.area02')}}</h2>
    <div class="itemBlock">
      <p>
        {{$t('avatamsaka.researcher.area02content')}}
      </p>
    </div>
  </div>

  <div class="itemsBlocks">
    <div class="sectionBack">
    </div>
    <h2>{{$t('avatamsaka.researcher.area03')}}</h2>
    <div class="itemBlock">
      <img src="@/../static/image/content/researcherPageArea.jpg" />
      <p>
        {{$t('avatamsaka.researcher.area03content')}}
      </p>
    </div>
  </div>


</div>
</template>

<script>

export default {
  name: 'researcher',
  data() {
    return {
    };
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#researcher {
  .sectionIntro {
      display: flex;
      padding-bottom: 50px;
      position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      height: 60%;
      background: #d9e2c4;
      position: absolute;
    }

    .sectionBack::after {
        border-top: 20vh solid #d9e2c4;
        border-right: 50vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;
    }

    .sectionContent{
      display: flex;
      position: relative;
      width: 100%;
      .introCover {
        position: sticky;
        flex: 1;
        padding: 0px;
        margin: 0px;
        img {
          max-width: 300px;
          width: 100%;
          float: right;
          margin: 60px 40px;
        }
      }
      .introContent {
        align-self: center;
        p {
          padding: 20px;
          padding-left: 0px;
          max-width: 800px;
        }
        position: sticky;
        flex: 1;
        margin: 60px 0px;
        padding: 20px;
        text-align: left;
        align-self: left;
      }
    }


    @media (max-width: 768px) {

        display: block;
        flex-direction: row;

        .introCover, .introContent {
          clear: both;
          display: block;
          width: 100%;
          flex: none;
          margin: 0px;
          padding: 40px;
        }

        .sectionContent .introContent {
          h2 {
            margin: 0px;
          }
          p {
            padding: 0px;
          }
        }

        .sectionContent .introCover {
          position: relative;
          margin: 0;
          padding: 60px 20px;
          >img {
            width: 100%;
            margin: 0px;
          }
        }
    }
  }


  .itemsBlocks{
    text-align: left;
    margin: 0px;
    position: relative;
    h2 {
      position: sticky;
      margin: 0.8em auto;
      padding-left: 100px;
      padding-right: 100px;
    }
    .itemBlock {
      position: sticky;
      padding-left: 100px;
      padding-right: 100px;
      padding-bottom: 100px;
      height: 100%;
      overflow: hidden;
      img {
        max-width: 600px;
        max-height: 100%;
        padding-left: 40px;
        overflow: hidden;
        position: relative;
        float: right;
        clear: right;
      }
    }

    .sectionBack {
      bottom: 0px;
      width: 100%;
      height: 20%;
      min-height: 20px;
      background: #d9e2c4;
      position: absolute;
    }
    .sectionBack::after {
      border-bottom: 20vh solid #d9e2c4;
      border-left: 50vw solid transparent;
      content: "";
      bottom: 100%;
      right: 0;
      position: absolute;
    }

    @media (max-width: 768px) {
      padding: 1em;
      h2 {
        text-align: center;
        padding: 0px;
      }
      .itemBlock {
        padding: 0px;
      }
      .sectionBack {
        left: 0;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Researcher.vue